/* eslint-disable @typescript-eslint/no-unused-vars */
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { ROUTES } from './sidebar-items';
import { AuthService } from 'src/app/core/service/auth.service';
import { RouteInfo } from './sidebar.metadata';
import { AppService } from 'src/app/services/app/app.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { AlertComponent } from 'src/app/pages/alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
import { AgreeTermsConditionComponent } from 'src/app/pages/package-management/agree-terms-condition/agree-terms-condition.component';
import { CommonService } from 'src/app/services/common/common.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems!: RouteInfo[];
  public innerHeight?: number;
  public bodyTag!: HTMLElement;
  listMaxHeight?: string;
  listMaxWidth?: string;
  userFullName?: string;
  userImg?: string;
  userType?: string;
  headerHeight = 60;
  currentRoute?: string;
  groupType?: string;
  routerObj;
  menuIcon = 'radio_button_checked';
  activePath!: string;
  public sidebarAccess: any;
  public isRoutingAllowed: boolean = false;
  @ViewChild('routeMain') routeMain !: ElementRef;
  private subscription!: Subscription;
  accessMenu: any[] = [];

  hideBetweenUserAndUpload = false;
  hideAfterUploadDocument = false;
  userManagementIndex = -1;
  uploadDocumentIndex = -1;

  miniAndMaxiSideBar = false;
  minMaxByWindowWidth = false;
  toggleSidebarSubMenu = false;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    private router: Router,
    private appService: AppService,
    private dialog: MatDialog,
    private commonService: CommonService

  ) {
    this.elementRef.nativeElement.closest('body');
    this.routerObj = this.router.events.subscribe((event) => {

      if (event instanceof NavigationEnd) {
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
      if (event instanceof NavigationStart) {
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });

  }
  @HostListener('window:resize', ['$event'])
  windowResizecall() {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }
  ngOnInit() {
    // bydefault we set the sidebar  width here [dont remove this line]
    document.documentElement.style.setProperty('--sidebar-width', '300px');

    if (this.authService.currentUserValue) {
      this.userFullName =
        this.authService.currentUserValue.firstName + ' ' + this.authService.currentUserValue.lastName;
      this.userImg = this.authService.currentUserValue.img;


      // logic to filter the side menu based on the user type (i.e company and individual)
      this.setSidebarStatus()

      this.commonService.acceptData$.subscribe((value) => {
        if (value == 'terms_clicked') {
          this.onAgreeModal()
        }
      })
    }
    // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
    const sideMenuElement = document.getElementById('menu-item');
    this.subscription = this.commonService.data$.subscribe((value) => {
      // this.data = value;
      if (value == "offer_purchased") {
        this.setSidebarStatus()
        sideMenuElement?.classList.remove('m-bt');
      }
    });
    let userData = JSON.parse(this.appService.getData('training-portal.userInfo'))
    this.groupType = userData.group_type;

    //removing this from here as has directly added that in the offer package component 
    // if(window.location.href.includes('offer-package')&&  userData.t_off==0){
    //   sideMenuElement?.classList.add('m-bt');
    // }
  }
  closeSidebar(event: Event) {
    this.renderer.removeClass(this.document.body, 'overlay-open');
  }
  setSidebarStatus() {
    let userData = JSON.parse(this.appService.getData('training-portal.userInfo'))
    this.userType = userData.group_type;
    if (this.userType === 'manager') {

      if (userData.access != null) {

        let acc = JSON.parse(userData?.access)

        if (acc.length > 0) {
          this.accessMenu = JSON.parse(userData?.access).map(item => {
            if (item === 'dashboard') return 'manager_dashboard';
            if (item === 'user_management') return 'manager_employee_management';
            if (item === 'document_management') return 'upload_document';
            // if (item === 'course_dashboard') return 'inh_course';
            if (item === 'important_notice') return 'notice';
            if (item === 'company_forum') return 'forum';
            if (item === 'certificate_management') return 'certificate';
            // if (item === 'department_management') return 'dept_management';
            if (item === 'new_recruitment') return 'recruitment';

            // if (item === 'course_builder') return 'course_builder';
            if (item === 'course_playlist') return 'course_playlist';
            if (item === 'staff_survey') return 'staff_survey';
            if (item === 'quick_task') return 'qui_task';
            if (item === 'workflow') return 'workflow';
            if (item === 'usr_event') return 'user_event';
            if (item === 'time_clock') return 'time_management';
            if (item === 'time_off') return 'time_off_management';


            return item;
          });
          this.accessMenu.push('manager');
          this.accessMenu.push('manager_coursework_management', 'manager_event_management');
        } else {
          this.accessMenu.push('manager_dashboard')
          this.accessMenu.push('manager');
        }
      } else {
        this.accessMenu.push('manager_dashboard')
        this.accessMenu.push('manager');
      }

      // this.accessMenu = JSON.parse(userData?.access).map(item => {
      //   if (item === 'dashboard') return 'manager_dashboard';
      //   if (item === 'user_management') return 'manager_employee_management';
      //   if (item === 'document_management') return 'upload_document';
      //   if (item === 'course_dashboard') return 'inh_course';
      //   if (item === 'important_notice') return 'notice';
      //   if (item === 'company_forum') return 'forum';
      //   if (item === 'certificate_management') return 'certificate';
      //   if (item === 'department_management') return 'dept_management';
      //   return item;
      // });
      // this.accessMenu.push('manager');
      // this.accessMenu.push('manager_coursework_management','manager_event_management');
      this.sidebarItems = ROUTES.filter((sidebarItem) => {
        if (this.accessMenu.includes(sidebarItem.itemName)) {
          if (sidebarItem.userType.includes('individual')) return;
          if (!sidebarItem.userType.includes('manager')) {
            sidebarItem.userType.push('manager');
          }
          return true;
        }
        return false;
      });
    } else {
      this.sidebarItems = ROUTES.filter((sidebarItem) => (sidebarItem.userType.includes(this.userType)));
    }

    // the sidebar access we get here from API's login
    this.sidebarAccess = userData.side_bar;
    let isTermsAccepted = userData.t_acp;
    let isOfferPurchased = userData.t_off;
    //  this.sidebarItems = ROUTES
    // const perm = this.appService.getPermissionforUser();
    // this.sidebarItems = ROUTES.filter(item=>perm.includes(item.itemName)&&item.userType.includes(this.userType))
    this.sidebarItems.forEach(item => {
      const isCompany = this.userType === 'company';
      const isIndividual = this.userType === 'individual';
      const isManager = this.userType === 'manager';

      if (isCompany) {
        item.is_access = userData.t_off === 0 ? 0 : this.sidebarAccess[item.itemName];
        if (['package', 'offer_package', 'course_playlist', 'recruitment', 'dashboard',].includes(item.itemName)) {
          item.is_access = 1;
        }
        if (item.itemName === 'package') {
          item.submenu.forEach(i => {
            // this variable preseerves value i.e if it has purchased the sell package then make value 1 which will help to open  type of modal 
            // that is buy modal and terms and condition modal
            if (this.sidebarAccess['sell_course'] == 1 && i.itemName === 'sell_package' && isOfferPurchased) {
              i.is_sell_course_bought = 1
            }
            else {
              i.is_sell_course_bought = 0
            }
            if (isTermsAccepted === 0 && i.itemName === 'sell_package') {
              i.is_access = i.is_terms = 0;
            } else {
              i.is_access = 1;
            }
          });
        }
        // if (item.itemName === 'course_builder' && isTermsAccepted === 0) {
        //   item.is_access = item.is_terms = 0;
        // }
      }
      else if (isManager) {
        if (this.accessMenu.includes(item.itemName)) {
          item.is_access = 1;
        } else {
          item.is_access = 0;
        }
      }
      else if (isIndividual && ['sell_package', 'course_builder'].includes(item.itemName) && isTermsAccepted === 0) {
        item.is_access = item.is_terms = 0;
      } else {
        item.is_access = 1;
      }
    });

  }


  getRouterLink(): any[] | null {
    // return this.isRouterLinkActive ? ['/path'] : null;
    return null;
  }
  callToggleMenu(event: Event, length: number) {
    this.isRoutingAllowed = true;
    if (length > 0) {
      const parentElement = (event.target as HTMLInputElement).closest('li');
      const activeClass = parentElement?.classList.contains('active');

      if (activeClass) {
        this.renderer.removeClass(parentElement, 'active');
        this.minimizeMaximizeSidebar(true)
      } else {
        this.renderer.addClass(parentElement, 'active');
        this.minimizeMaximizeSidebar(true)

      }
    }
  }
  // mainRoute(sClass,path){
  onMain(path) {
    this.router.navigate([path])
  }
  goToRoute(event: Event, length: number, path) {
    if (length > 0) { }
    else {
      this.router.navigate([path])
      this.callToggleMenu(event, length)
    }
  }
  goToRouteNew(event: Event, length: number, path, item) {

    if (item.itemName == "course_store" && this.userType != "individual") {
      this.router.navigate(['/course/course-store'])
    } else if (this.userType == "individual" && item.is_access == 0 && item.is_terms == 0) {
      this.onAgreeModal()
    }
    else {
      // if company then check sell package or not if sell package is purchased then check if terms accepted or not.
      if (item.itemName == "sell_package") {
        if (item.is_sell_course_bought == 0) {
          const dialogRef = this.dialog.open(AlertComponent, Object.assign({
            data: { api_type: 'please_buy', }
          }));
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
            }
          });
        }
        else if (item.is_terms == 0) {
          this.onAgreeModal()
        }
      }
      // if(item.is_terms == 0){
      //   this.onAgreeModal()
      // }
      else {
        const dialogRef = this.dialog.open(AlertComponent, Object.assign({

          data: { api_type: 'please_buy', }
        }));
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
          }
        });
      }
    }
  }
  onAgreeModal() {
    const dialogRef = this.dialog.open(AgreeTermsConditionComponent, {
      panelClass: 'agree-modal',
      enterAnimationDuration: '200ms', exitAnimationDuration: "200ms",
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["accepted"] == true) {
        this.sidebarItems.map(item => {
          // when accepting terms and condition to  make is_terms = 1
          if (this.userType == "individual") {
            if ((item.itemName == 'sell_package' || item.itemName == "course_builder")) {
              item["is_access"] = 1
              item["is_terms"] = 1
            }
            else {
              item["is_access"] = 1
            }
          }
          else {
            if (item.itemName == "course_builder") {
              item["is_access"] = 1
              item["is_terms"] = 1
            }
            if (item.itemName == "package") {
              item.submenu.map(i => {
                if (i.itemName == 'sell_package') {
                  i["is_access"] = 1
                  i["is_terms"] = 1
                }
              })
            }
          }
        })
        let userData = JSON.parse(this.appService.getData('training-portal.userInfo'))
        userData["t_acp"] = 1
        this.appService.storeData('training-portal.userInfo', JSON.stringify(userData));
        if (this.userType == 'company') {
          this.router.navigate(['/package/sell'])
        }
        else {
          this.router.navigate(['/course/builder'])
        }
      }
    });
  }

  isActive(path: string): boolean {
    // Check if the current path matches the active path
    return this.activePath == path;
  }
  initLeftSidebar() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    // this.listMaxHeight = height + '';
    this.listMaxHeight = height - 80 + ''; //by ankush

    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  isCloseButtonShow() {
    return window.innerWidth < 1170;
  }
  checkStatuForResize(firstTime: boolean) {
    if (window.innerWidth < 1170) {

      //this four line is for mini mize and maximize sidebar when window resizing and width < 1170
      this.minMaxByWindowWidth = true;
      this.miniAndMaxiSideBar = false;
      const root = document.documentElement;
      root.style.setProperty('--sidebar-width', '300px'); //we set side bar width


      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.minMaxByWindowWidth = false
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }
  mouseHover() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }
  mouseOut() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
  mobileMenuSidebarOpen(event: Event, className: string) {
    const hasClass = (event.target as HTMLInputElement).classList.contains(
      className
    );
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
      this.menuIcon = 'radio_button_checked';
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
      this.menuIcon = 'radio_button_unchecked';
    }

    const sideClosedHover =
      this.document.body.classList.contains('side-closed');
    if (sideClosedHover) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
    }
  }
  logout() {
    this.authService.logout().subscribe((res) => {
      if (!res.success) {
        this.router.navigate(['/authentication/signin']);
      }
    });
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
    this.subscription.unsubscribe()
  }


  toggleAfterUserManagement(index: number): void {
    const uploadIndex = this.getUploadDocumentIndex();
    if (this.sidebarItems[index].itemName === 'user_management') {
      this.userManagementIndex = index;
      this.uploadDocumentIndex = uploadIndex;
      this.hideBetweenUserAndUpload = !this.hideBetweenUserAndUpload;
    } else if (this.sidebarItems[index].itemName === 'upload_document') {
      this.uploadDocumentIndex = index;
      this.hideAfterUploadDocument = !this.hideAfterUploadDocument;
    }
  }

  getUploadDocumentIndex(): number {
    return this.sidebarItems.findIndex(item => item.itemName === 'upload_document');
  }

  showItem(index: number): boolean {
    const currentItem = this.sidebarItems[index];
    // Hide all items between user_management and upload_document, INCLUDING upload_document
    if (
      this.hideBetweenUserAndUpload &&
      this.userManagementIndex !== -1 &&
      this.uploadDocumentIndex !== -1 &&
      index > this.userManagementIndex &&
      index <= this.uploadDocumentIndex // <-- now includes upload_document
    ) {
      this.toggleSidebarSubMenu = true
      return false;
    } else {
      this.toggleSidebarSubMenu = false
    }

    // Hide all items after upload_document
    if (
      this.hideAfterUploadDocument &&
      this.uploadDocumentIndex !== -1 &&
      index > this.uploadDocumentIndex
    ) {
      return false;
    }

    return true;
  }


  //this function is for minimize and maximixe sidebar
  minimizeMaximizeSidebar(subMenu: boolean) {
    if (subMenu && !this.miniAndMaxiSideBar) return;
    this.miniAndMaxiSideBar = !this.miniAndMaxiSideBar
    const root = document.documentElement;
    if (this.miniAndMaxiSideBar == true) {
      root.style.setProperty('--sidebar-width', '100px');
    } else {
      root.style.setProperty('--sidebar-width', '300px');
      this.hideBetweenUserAndUpload = false;
      this.hideAfterUploadDocument = false;
      this.toggleSidebarSubMenu = false;
    }
  }

}